<template>
  <header class="header">
    <div class="header-container">
      <div class="logo">株洲高新区企业出海服务平台</div>
      <nav class="nav">
        <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">首页</router-link>
        <router-link to="/one-stop-service" class="nav-item" :class="{ active: $route.path === '/one-stop-service' }">出海一件事</router-link>
        <router-link to="/policy-info" class="nav-item" :class="{ active: $route.path === '/policy-info' }">政策资讯</router-link>
        <router-link to="/activity-publish" class="nav-item" :class="{ active: $route.path === '/activity-publish' }">活动发布</router-link>
        <router-link to="/supply-demand" class="nav-item" :class="{ active: $route.path === '/supply-demand' }">供需对接</router-link>
        <!-- <a href="#" class="nav-item">金融服务</a> -->
        <a href="https://globaltradehelpdesk.org/zh" class="nav-item">全球服务商</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style scoped>
/* 顶部导航栏样式 */
.header {
  padding: 0;
  height: 60px;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  position: relative;
}

.logo {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 1px;
  white-space: nowrap;
  margin-right: 20px;
}

.nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: transparent;
}

.nav-item {
  margin: 0 15px;
  text-decoration: none;
  color: #fff;
  padding: 0 5px;
  position: relative;
  font-size: 15px;
  transition: all 0.3s ease;
  font-weight: normal;
  height: 60px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.nav-item:hover {
  color: #fff;
}

.nav-item.active {
  color: #fff;
  font-weight: normal;
  border-bottom: 3px solid #fff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    height: auto;
  }
  
  .logo {
    font-size: 16px;
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .nav {
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    height: auto;
  }
  
  .nav-item {
    margin: 0 10px;
    font-size: 14px;
    height: auto;
    padding: 5px;
  }
}
</style>